module.exports = __webpack_public_path__ + "static/media/UndoBlue.ff12f8de.svg";